import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { EmbedClient } from '../../login/v1/typings';
import { getEmbedClientFromBrowser } from '../utils/embed-client-pure';

const useEmbedClient = (): EmbedClient | null => {
  const location = useLocation();

  return useMemo(() => {
    return getEmbedClientFromBrowser();
  }, [location.search]);
};

export default useEmbedClient;
